import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconArrowRightStyle0 = gravityIconIndividualCss;

const GravityIconArrowRight = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: 'bc86b1155ae5b9f666b9cb6f3b35a4c460f3b3de', color: this.color, size: this.size }, h("svg", { key: 'da476c0ae4c9ff83467a0cde6a4ac090eeba538f', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'b5f00cc29892a31eb9c83b72c5fe0116171e546f', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M13.79 10.79 8.51 5.51a.3.3 0 0 0-.51.21v10.56a.3.3 0 0 0 .51.21l5.28-5.28a.29.29 0 0 0 0-.42Z", fill: "currentColor" }))));
    }
};
GravityIconArrowRight.style = GravityIconArrowRightStyle0;

export { GravityIconArrowRight as gravity_icon_arrow_right };

//# sourceMappingURL=gravity-icon-arrow-right.entry.js.map